import { FC, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Logo from 'src/components/elements/logo/Logo'
import TestimonialSection from 'src/components/pages/registration/testimonials/TestimonialSection'

interface IAuthShell {
  title: string
  subtitle?: ReactNode
  children: ReactNode
}

// The sign-in family — sign in, sign up, finishing a social sign-up, a new
// password: the form under the logo on the left, people's stories on the
// right (under the form on a phone). The title is the page's h1.
const AuthShell: FC<IAuthShell> = ({ title, subtitle, children }) => {
  const { t } = useTranslation()
  return (
    <div className="flex md:flex-row flex-col md:justify-between gap-8 md:gap-6 md:min-h-[calc(100vh-4rem)]">
      <div
        data-auth-column
        className="flex flex-col w-full md:max-w-[41.5rem] px-4 pt-8 md:px-5 md:py-10"
      >
        <header className="flex items-center gap-3 md:gap-5">
          <Link to="/" className="flex items-center h-12 md:h-16 shrink-0">
            <Logo
              className="h-full"
              imageClassName="w-[9.5rem] md:w-[12rem] h-full"
              textClassName="text-lg md:text-2xl"
            />
          </Link>
          <span aria-hidden="true" className="shrink-0 w-px h-10 bg-ink/[0.18]" />
          <p className="m-0 max-w-[12.5rem] text-[0.8125rem] md:text-sm leading-[1.125rem] md:leading-5 text-ink-2">
            {t('tagline')}
          </p>
        </header>
        <div className="flex flex-col gap-6 w-full md:max-w-[28rem] py-8 md:my-auto">
          <div className="flex flex-col gap-2">
            <h1 className="m-0 text-[1.75rem] font-black leading-[2.125rem] text-ink">{title}</h1>
            {subtitle && <div className="text-base leading-6 text-ink-2">{subtitle}</div>}
          </div>
          {children}
        </div>
      </div>
      <TestimonialSection />
    </div>
  )
}

export default AuthShell
